<div class="picker-host">
  <div class="picker-toolbar">
    <app-toolbar-search
      [placeholder]="'vendor_member_picker.search_inventory_placeholder' | transloco"
      [ariaLabel]="'vendor_member_picker.search_vendors_aria' | transloco"
      [maxWidth]="null"
      [value]="search()"
      (valueChange)="search.set($event)"
    />
    <span class="picker-count" role="status">{{
      (selectedCount() === 1
        ? 'vendor_member_picker.selected_one'
        : 'vendor_member_picker.selected_other'
      ) | transloco: { count: selectedCount() }
    }}</span>
  </div>

  @if (!hasMatches()) {
    <p class="panel-picker-empty">
      {{
        (search().trim()
          ? 'vendor_member_picker.no_matches'
          : 'vendor_member_picker.no_approved_vendors'
        ) | transloco
      }}
    </p>
  } @else {
    <div class="panel-picker-list">
      @for (row of rows(); track row.vendorId) {
        <div class="member-row" [class.is-selected]="row.selected">
          <div class="member-row-controls">
            <button
              type="button"
              class="panel-picker-item"
              #vendorToggle
              [attr.data-vendor-id]="row.vendorId"
              [class.selected]="row.selected"
              [attr.aria-pressed]="row.selected"
              (click)="toggleVendor(row.vendorId)"
            >
              <span class="panel-picker-check" aria-hidden="true"><mat-icon>check</mat-icon></span>
              <app-org-logo [logoUrl]="row.logoUrl" [name]="row.name" size="sm" />
              <span class="member-info">
                <span class="member-name-row">
                  <span class="member-name">{{ row.name }}</span>
                  @if (row.verified) {
                    <mat-icon
                      class="member-verified-mark"
                      [title]="'vendor_member_picker.verified_vendor_title' | transloco"
                      [attr.aria-label]="'vendor_member_picker.verified_vendor_aria' | transloco"
                      >verified</mat-icon
                    >
                  }
                </span>
                <span class="member-meta">
                  <span>{{ row.typeLabel }}</span>
                  @if (row.country) {
                    <span aria-hidden="true">·</span>
                    <span [title]="row.countryName"
                      >{{ row.countryFlag }} {{ row.countryName }}</span
                    >
                  }
                </span>
              </span>
            </button>
            @if (row.selected) {
              <button
                type="button"
                class="member-expand-btn"
                [class.expanded]="row.expanded"
                (click)="toggleExpand(row.vendorId, $event)"
                [attr.aria-label]="
                  row.name +
                  ': ' +
                  ((row.expanded
                    ? 'vendor_member_picker.hide_products_aria'
                    : 'vendor_member_picker.show_products_aria'
                  ) | transloco)
                "
                [attr.aria-expanded]="row.expanded"
                [attr.aria-controls]="'vendor-products-' + row.vendorId"
              >
                <span>{{ row.scopeLabelKey | transloco: { count: row.productCount } }}</span>
                <mat-icon aria-hidden="true">expand_more</mat-icon>
              </button>
            }
          </div>
          @if (row.selected && row.expanded) {
            <div
              class="member-products"
              [attr.aria-busy]="row.loading"
              [id]="'vendor-products-' + row.vendorId"
              [attr.aria-label]="row.name + ' — ' + ('vendor_member_picker.products' | transloco)"
              role="group"
            >
              @if (row.loading) {
                <p class="product-message" role="status">
                  {{ 'vendor_member_picker.loading_products' | transloco }}
                </p>
              } @else if (row.failed) {
                <div class="product-toolbar">
                  <p class="product-message" role="status">
                    {{ 'vendor_member_picker.products_error' | transloco }}
                  </p>
                  <button
                    type="button"
                    class="panel-link-btn"
                    (click)="fetchProductsIfNeeded(row.vendorId)"
                  >
                    {{ 'vendor_member_picker.retry' | transloco }}
                  </button>
                </div>
              } @else if (row.products.length === 0) {
                <p class="product-message">
                  {{ 'vendor_member_picker.no_products_registered' | transloco }}
                </p>
              } @else {
                <div class="product-toolbar">
                  <span class="product-label">{{
                    'vendor_member_picker.products' | transloco
                  }}</span>
                  @if (row.allProducts) {
                    <span class="product-summary">{{
                      'vendor_member_picker.all_included' | transloco
                    }}</span>
                  } @else {
                    <button
                      type="button"
                      class="panel-link-btn all-products-btn"
                      (click)="selectAllProducts(row.vendorId)"
                    >
                      {{ 'vendor_member_picker.select_all' | transloco }}
                    </button>
                  }
                </div>
                <div class="product-options">
                  @for (product of row.products; track product.product_id) {
                    <button
                      type="button"
                      class="member-product-check panel-picker-item"
                      [class.selected]="product.selected"
                      [attr.aria-pressed]="product.selected"
                      (click)="toggleProduct(row.vendorId, product.product_id)"
                    >
                      <span class="panel-picker-check" aria-hidden="true"
                        ><mat-icon>check</mat-icon></span
                      >
                      <span>{{ product.name }}</span>
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
